type ProjectNameSource = {
  name?: string | null
  projectGroup?: { name?: string | null } | string | null
}

/** Project label shared by managed models and nested API data. */
export function getProjectDisplayName(project?: ProjectNameSource | string | null): string {
  if (!project || typeof project === "string") return ""
  const name = project.name ?? ""
  if (!name) return ""
  const group = project.projectGroup
  const groupName = group && typeof group !== "string" ? group.name : undefined
  return groupName ? `${groupName} ${name}` : name
}
